import {trackerEventApi} from 'common/api/entitiesApi'
import {FC} from 'react'

import {DictionarySelector, DictionarySelectorProps} from './DictionarySelector'

export const EventReportSelector: FC<DictionarySelectorProps> = ({ multiple = true, mode, ...props }) => (
  <DictionarySelector
    {...props}
    cacheKey="event"
    loader={() => trackerEventApi.trackerEventPage(
        undefined, undefined, undefined, undefined
    ).then(list => {
        const result = new Array<any>()
        if (list && list.data) {
            list.data.forEach(eventData => {
                if (eventData && eventData.data) {
                    const event = eventData.data
                    result.push({id: event.id + "", name: event.name})
                    if (eventData.data.withPrice) {
                        result.push({id: event.id + "_amount", name: event.name + " (Amount)"})
                    }
                }
            })
        }
        return result
    })}
    errorText="Can't load available countries"
    mode={multiple ? (mode ?? 'multiple') : undefined}
  />
)
